import { API_AUTH } from "../common";

const DongTienApi = {
  getBaoCao: (dateFrom, dateTo, hinhThucThanhToan) =>
    API_AUTH.get(
      `bao-cao/dong-tien1?DateFrom=${dateFrom}&DateTo=${dateTo}&hinhThucThanhToan=${hinhThucThanhToan}`
    ),
  getChiTiet: (
    category,
    flow,
    dateFrom,
    dateTo,
    pageIndex,
    pageSize,
    hinhThucThanhToan
  ) =>
    API_AUTH.get(
      `bao-cao/dong-tien/chi-tiet?category=${category}&flow=${flow}&dateFrom=${dateFrom}&dateTo=${dateTo}&pageIndex=${pageIndex}&pageSize=${pageSize}&hinhThucThanhToan=${hinhThucThanhToan}`
    ),
  getChiTietGiaoDich: (id) =>
    API_AUTH.get(`bao-cao/dong-tien/giao-dich-chi-tiet?id=${id}`),
};
export default DongTienApi;
